import { render, staticRenderFns } from "./addModal.vue?vue&type=template&id=d00b1f74"
import script from "./addModal.vue?vue&type=script&lang=js"
export * from "./addModal.vue?vue&type=script&lang=js"
import style0 from "./addModal.vue?vue&type=style&index=0&id=d00b1f74&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d00b1f74')) {
      api.createRecord('d00b1f74', component.options)
    } else {
      api.reload('d00b1f74', component.options)
    }
    module.hot.accept("./addModal.vue?vue&type=template&id=d00b1f74", function () {
      api.rerender('d00b1f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/demageManage/addModal.vue"
export default component.exports